import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {}

export const Container: FC<ContainerProps> = ({ className, ...props }) => (
  <div className={classNames('container px-6 sm:px-8 md:px-10 max-w-7xl', className)} {...props} />
);
